import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getOrderInProgress } from '../../selectors/order'
import { isTabbed } from '../../utils/orderStates'
import { getCashEnabled, makeGetNoOpTenders } from '../../selectors/revenueCenter'
import { PAYMENT_TYPES_INTERNAL } from '../../utils/paymentTypes'
import { getIsPreAuthTab } from '../../utils/orderUtils'
import { reduce } from '../../VNUtil/VNUtils'

export const useTenders = () => {
  const order = useSelector((state) => getOrderInProgress(state))
  const noOpTenders = useSelector((state) => makeGetNoOpTenders()(state))
  const cashEnabled = useSelector((state) => getCashEnabled(state))

  /**
   * Formats currently selected payment
   */
  const getSavedPaymentAsTender = useCallback(() => {
    const prefix = order.paymentDisplay || order?.cardReaderData?.cardIssuer
    let suffix = ''

    if (order?.cardReaderData?.cardholderName) {
      suffix = `- ${order.cardReaderData.cardholderName}`
    }

    return [PAYMENT_TYPES_INTERNAL.SAVED_CARD, `${prefix} ${suffix}`, false]
  }, [order])

  /**
   * Tender Selection as Required for BackBar
   */
  const getBackBarTenders = useCallback(() => {
    let paymentTypes = []

    // currently pre-authorized Card
    if (getIsPreAuthTab(order) && isTabbed(order)) {
      paymentTypes.push(getSavedPaymentAsTender())
    }

    // custom tenders
    paymentTypes = reduce(
      noOpTenders,
      (tenders, tender) => {
        return [...tenders, [tender.name, tender.displayName, tender.managerApproval]]
      },
      paymentTypes,
    )

    // card is always an option
    paymentTypes.push(['card', 'Card'])

    // cash
    if (cashEnabled) {
      paymentTypes.push(['cash', 'Cash', false])
    }

    return paymentTypes
  }, [cashEnabled, getSavedPaymentAsTender, noOpTenders, order])

  return {
    getBackBarTenders,
  }
}

export default useTenders
